"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = void 0;
const _Actions = require("../../modules/finishings/actions");
exports.Actions = _Actions.default('distribution');
//# sourceMappingURL=finishings.js.map